import React, { useState, useMemo, useEffect } from 'react'

export interface StepProps<T,D> {
  nextStep: () => void
  goToStep: (step: number) => void
  setLargePopup: (large: boolean) => void
  data: T
  setData: (data: T) => void
  stepData: D
  setStepData: (data: D) => void
}

export interface Props<T,D> {
  steps: React.FunctionComponent<StepProps<T,D>>[]
  title: string
  onClose: () => void
  large?: boolean
  data: T
  setData: (data: T) => void
  defaultStepData: D
}

function Popup<T, D> (props: Props<T, D>): JSX.Element {
  const { steps, title, onClose, large, data, setData, defaultStepData } = props
  const [ showStep, setShowStep ] = useState<number>(0)
  const [ largePopup, setLargePopup] = useState<boolean>(large)
  const [ stepData, setStepData ] = useState<any>(defaultStepData)

  const nextStep = (): void => {
    if (typeof steps[showStep + 1] === 'undefined')
      return
    setShowStep(showStep + 1)
  }
  const prevStep = (): void => {
    if (typeof steps[showStep - 1] === 'undefined')
      return
    setShowStep(showStep - 1)
  }

  const Content = useMemo<React.FunctionComponent<StepProps<T,D>>>(() => {
    return steps[showStep] ?? null
  }, [ showStep ])

  useEffect(() => {
    document.body.style.overflowY = 'hidden'

    return () => {
      document.body.style.overflowY = 'auto'
    }
  }, [])

  const mainClass = [ 'popup__main' ]
  if (largePopup)
    mainClass.push('popup__main--large')

  return <div className="popup">
    <div className="popup__background"></div>
    <div className={mainClass.join(' ')}>
      <div className="popup__title-bar">
        <a href="#" onClick={(evt) => {
          evt.preventDefault()
          prevStep()
        }}>«</a>
        <h3 className="popup__title">{title}</h3>
        <a href="#" onClick={(evt) => {
          evt.preventDefault()
          onClose()
        }}>×</a>
      </div>
      <div className="popup__content">
        {Content &&
          <Content
            nextStep={nextStep}
            goToStep={(step: number) => setShowStep(step)}
            setLargePopup={setLargePopup}
            data={data}
            setData={setData}
            stepData={stepData}
            setStepData={setStepData}
          />
        }
      </div>
    </div>
  </div>
}

export default Popup

